"use client"
import { useState } from "react"
import Image from "next/image"

function CardContent({ onWechat }: { onWechat: () => void }) {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-sky-300 to-cyan-200 flex items-center justify-center text-white text-lg font-bold shrink-0">哈</div>
        <div>
          <h1 className="text-base font-bold text-[#1a1a1b]">马小哈希</h1>
          <p className="text-[#8590a6] text-xs">maxiaohash</p>
        </div>
      </div>
      <p className="text-[#646464] text-sm leading-relaxed">
        记录我的技术，生活，自媒体。分享我的有趣或者无趣的一切。希望有一天AI取代人类的时候，我有好多材料可以供他学习。
      </p>
      <div className="text-xs text-[#8590a6] border-t border-gray-100 pt-3 space-y-1.5">
        <div className="text-[#1a1a1b] font-medium text-xs">开源代码库</div>
        <div className="flex gap-3">
          <a href="https://github.com/mazhenkai" target="_blank" rel="noopener noreferrer" className="text-sky-500 underline underline-offset-2 hover:text-sky-600 transition-colors">GitHub</a>
          <a href="https://gitee.com/mazhenkai" target="_blank" rel="noopener noreferrer" className="text-sky-500 underline underline-offset-2 hover:text-sky-600 transition-colors">Gitee</a>
        </div>
        <div className="text-[#c0c8d4]">（欢迎多star与关注呀，虽然很多项目不公开，嘻嘻）</div>
      </div>
      <div className="space-y-1.5 text-xs text-[#8590a6] border-t border-gray-100 pt-3">
        <div className="text-[#1a1a1b] font-medium text-xs mb-2">联系我</div>
        <div>
          <span>微信：</span>
          <button onClick={onWechat} className="text-sky-500 underline underline-offset-2 hover:text-sky-600 transition-colors text-left">maxiaoha101</button>
          <span className="text-[#c0c8d4] ml-1">（上网专用，几天看一次，统一添加好友）</span>
        </div>
        <div>
          <span>邮箱：</span>
          <a href="mailto:ma.zhenkai@foxmail.com" className="text-sky-500 underline underline-offset-2 hover:text-sky-600 transition-colors">ma.zhenkai@foxmail.com</a>
          <span className="text-[#c0c8d4] ml-1">（异步沟通，可直接说明来意与添加必要附件）</span>
        </div>
      </div>
    </div>
  )
}

export function ProfileCardDesktop() {
  const [showQR, setShowQR] = useState(false)
  return (
    <>
      <section className="clay bg-white rounded-b-3xl px-5 py-5">
        <CardContent onWechat={() => setShowQR(true)} />
      </section>
      {showQR && <QRModal onClose={() => setShowQR(false)} />}
    </>
  )
}

export function ProfileCardMobile() {
  const [showQR, setShowQR] = useState(false)
  const [showPanel, setShowPanel] = useState(false)
  return (
    <>
      <div className="md:hidden fixed top-20 right-3 z-50">
        <button onClick={() => setShowPanel(s => !s)}
          className="w-12 h-12 rounded-full bg-gradient-to-br from-sky-400 to-cyan-300 flex items-center justify-center text-white text-sm font-bold shadow-xl ring-2 ring-white">
          哈
        </button>
        {showPanel && (
          <div className="absolute right-0 top-11 w-72 clay bg-white rounded-2xl px-4 py-4 shadow-xl">
            <button onClick={() => setShowPanel(false)} className="absolute top-3 right-3 text-gray-300 hover:text-gray-500 text-lg leading-none">×</button>
            <CardContent onWechat={() => { setShowPanel(false); setShowQR(true) }} />
          </div>
        )}
      </div>
      {showQR && <QRModal onClose={() => setShowQR(false)} />}
    </>
  )
}

function QRModal({ onClose }: { onClose: () => void }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onClick={onClose}>
      <div className="bg-white rounded-2xl p-4 shadow-xl" onClick={e => e.stopPropagation()}>
        <p className="text-sm text-center text-gray-500 mb-3">扫码添加微信 · maxiaoha101</p>
        <Image src="/maxiaohash_wx_qr.jpg" alt="微信二维码" width={200} height={200} className="rounded-xl" />
        <p className="text-xs text-center text-gray-400 mt-2">点击空白处关闭</p>
      </div>
    </div>
  )
}
